<section class="layout py-12 lg:py-24 ">
  <div>
    <h2 class="text-3xl font-semibold mb-3">{{ 'nextAppointments' | translate }}</h2>

    <div class="px-4 md:px-40 bg-beige py-6 md:py-16 mt-10 border border-gray-200 rounded-lg">
      <app-date-picker (selectedChange)="setSelectedDate($event)" [customs]="customs()"
                       [depth]="2"></app-date-picker>

      <section class="mt-12 text-gray-900"><h2
        class="text-base font-semibold leading-6">{{ 'nextAppointments' | translate }}</h2>
        <ol class="mt-2 divide-y divide-gray-200 text-sm leading-6">
          @for (rendezVous of rendezVous(); track rendezVous.erpId) {
            <li class="py-4 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-40">
              <div class="md:col-span-2 grid grid-cols-3">
                <time [dateTime]="rendezVous.date" class="w-28 font-semibold">{{ rendezVous.date | date: 'fullDate' }}
                </time>
                <p class="text-bleuCaliceo-300 font-semibold">
                  {{ centerService.withErpId(rendezVous.centerErpId).name }}
                </p>
                <p class="text-bleuCaliceo-300 font-semibold">{{ rendezVous.label }}</p>
              </div>


              <div class="grid grid-cols-2">
                @if (rendezVousState(rendezVous); as state) {
                  <p class="font-semibold" [ngClass]="{
                  'text-red-500': state === 'waiting',
                  'text-gray-500': state === 'done',
                  'text-bleuCaliceo-300': state === 'confirmed',
                  }">{{ rendezVousState(rendezVous) | translate }}</p>
                }
                <div class="flex justify-between">
                  <p class="sm:ml-6">
                    <time [dateTime]="rendezVous.start">{{ rendezVous.start }}</time>
                    -
                    <time [dateTime]="rendezVous.end">{{ rendezVous.end }}</time>
                  </p>
                  <div appAutoClose="always" class="relative inline-block text-left">
                    <button>
                      <svg class="fill-gray-500 h-5 w-5" viewBox="0 0 128 512">
                        <path
                          d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/>
                      </svg>
                    </button>
                    <ul
                      class="absolute right-0 z-10 mt-2 w-80 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="0">
                      @if (rendezVous.seanceErpId) {
                        <li
                          class="text-gray-700 text-sm font-semibold"
                          role="menuitem" tabindex="0">
                          <button
                            class="w-full px-5 py-4 hover:bg-bleuCaliceo-300 disabled:bg-gray-300 hover:disabled:bg-gray-300 hover:bg-opacity-10 flex items-center gap-4"
                            (click)="drawerService.open({component: ConfirmCancelSeanceComponent, inputs: { rendezVous: rendezVous }, style: 'transparent'})"
                            (keyup.enter)="emulateClick($event)"
                            tabindex="0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4 fill-gray-500">
                              <path
                                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                            </svg>
                            <span>{{ 'cancel' | translate }}</span>
                          </button>
                        </li>
                      } @else if (rendezVous.prestationErpId) {
                        <li
                          class="text-gray-700 text-sm font-semibold"
                          role="menuitem" tabindex="0">
                          <button
                            class="w-full px-5 py-4 hover:bg-bleuCaliceo-300 disabled:bg-gray-300 hover:disabled:bg-gray-300 hover:bg-opacity-10 flex items-center gap-4"
                            (click)="drawerService.open({component: ConfirmCancelSpaComponent, inputs: { rendezVous: rendezVous }, style: 'transparent'})"
                            (keyup.enter)="emulateClick($event)"
                            tabindex="0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4 fill-gray-500">
                              <path
                                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                            </svg>
                            <span>{{ 'cancel' | translate }}</span>
                          </button>
                        </li>
                      }
                      <li
                        class="text-gray-700 flex items-center gap-5 px-5 py-4 text-sm hover:bg-bleuCaliceo-300 hover:bg-opacity-10 border-t border-gray-200"
                        role="menuitem" tabindex="0">
                        <a class="flex gap-4 items-center font-semibold" [href]="rendezVous.calendar.google | byPassUrl"
                           target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4 fill-gray-500">
                            <path
                              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
                          </svg>
                          {{ 'addToCalendar' | translate }} Google
                        </a>
                      </li>
                      <li
                        class="text-gray-700 flex items-center gap-5 px-5 py-4 text-sm hover:bg-bleuCaliceo-300 hover:bg-opacity-10 border-t border-gray-200"
                        role="menuitem" tabindex="0">
                        <a class="flex gap-4 items-center font-semibold" [href]="rendezVous.calendar.ical | byPassUrl"
                           target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4 fill-gray-500">
                            <path
                              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
                          </svg>
                          {{ 'addToCalendar' | translate }} Apple
                        </a>
                      </li>
                      <li
                        class="text-gray-700 flex items-center gap-5 px-5 py-4 text-sm hover:bg-bleuCaliceo-300 hover:bg-opacity-10 border-t border-gray-200"
                        role="menuitem" tabindex="0">
                        <a class="flex gap-4 items-center font-semibold"
                           [href]="rendezVous.calendar.outlook | byPassUrl" target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4 fill-gray-500">
                            <path
                              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
                          </svg>
                          {{ 'addToCalendar' | translate }} Outlook
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          } @empty {
            <li class="py-4">{{ 'noResultsFound'|translate }}</li>
          }
        </ol>
      </section>
    </div>
  </div>

</section>
